/**
 * Camera capture service: produces a still image from the current webcam view.
 * Testable; no React. Inject getScreenshot and container rect for tests.
 */

import { captureVideoRegionToDataUrl } from "../utils";

/**
 * Capture a still image from the webcam node.
 *
 * @param {object} webcamNode - Ref current from react-webcam (has .video and optionally .getScreenshot())
 * @param {object} options
 * @param {boolean} [options.fillHeight] - If true, crop video to cover container before capture
 * @param {{ width: number, height: number } | null} [options.containerRect] - Required when fillHeight is true
 * @param {string} [options.mimeType] - Default "image/png"
 * @returns {string | null} Data URL or null if capture failed
 */
export function captureFromWebcam(webcamNode, options = {}) {
  const { fillHeight = false, containerRect = null, mimeType = "image/png" } = options;
  if (!webcamNode) return null;

  const videoEl = webcamNode.video ?? webcamNode;
  if (!videoEl || videoEl.readyState < 2) return null;

  if (fillHeight && containerRect && containerRect.width > 0 && containerRect.height > 0) {
    const dataUrl = captureVideoRegionToDataUrl(videoEl, containerRect, mimeType);
    if (dataUrl) return dataUrl;
  }

  if (typeof webcamNode.getScreenshot === "function") {
    return webcamNode.getScreenshot();
  }
  return null;
}
